import type { DailyQueueEntry } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

export interface DailyQueueParams {
  // Required — mirrors the admin clips console's own sport-then-federation drill-down.
  sportId: string;
  // super_admin only; a federation_admin's own federation is used server-side regardless.
  federationId?: string;
  days?: number;
}

// The federation+sport's upcoming daily-clip rotation, from today onward — what the admin queue
// view renders as "what's next".
export async function getDailyQueue(params: DailyQueueParams): Promise<DailyQueueEntry[]> {
  const query: Record<string, string> = { sport_id: params.sportId };
  if (params.federationId) query['federation_id'] = params.federationId;
  if (params.days != null) query['days'] = String(params.days);
  const res = await api.get<Envelope<DailyQueueEntry[]>>('/admin/daily-queue', { params: query });
  return unwrap(res.data);
}

// Full-replace reorder: clipIds is the COMPLETE ordered list of the federation+sport's published
// clips (not a delta) — same "present ⇒ becomes exactly this" shape the tag-editing endpoints use.
// Returns the refreshed queue so the caller has a fresh list to render without a second round trip.
export async function reorderDailyQueue(
  sportId: string,
  clipIds: string[],
  federationId?: string,
): Promise<DailyQueueEntry[]> {
  const res = await api.put<Envelope<DailyQueueEntry[]>>('/admin/daily-queue/order', {
    sport_id: sportId,
    clip_ids: clipIds,
    federation_id: federationId,
  });
  return unwrap(res.data);
}
